import moment from "moment";
import showNotification from "./show_notification";

//  Select Unit 
const handleCheckboxChange = (index , selectedItems,setSelectedRowsUnit,status) => {
   setSelectedRowsUnit(prev => {
    const updatedRows = [...prev];
    const existingIndex = updatedRows.findIndex((row) => row.index === index);

    if (existingIndex !== -1) {
      updatedRows[existingIndex].isChecked = !updatedRows[existingIndex].isChecked;
      if (!updatedRows[existingIndex].isChecked) {
        updatedRows.splice(existingIndex, 1,);
      }
    } else {
      updatedRows.push({
        index,
        unit: status==="quantity" ? selectedItems.quantity[index].unit:selectedItems.unit_levels[index].unit,
        formula: status==="quantity" ?  selectedItems.quantity[index].value:selectedItems.unit_levels[index].value,
        value: 0,
        isChecked: true,
      });
    }
    return updatedRows;
   })
  };

// Enter Quantity for each unit
  const handleQuantityChange = (index, quantity,setSelectedRowsUnit) => {
  setSelectedRowsUnit(prev=>{
    const updatedRows = [...prev];
    const existingIndex = updatedRows.findIndex((row) => row.index === index);
    if (existingIndex !== -1 && updatedRows[existingIndex].isChecked) {
      updatedRows[existingIndex].value = quantity;
    }
    return updatedRows;
  })
  };

  const handleCheckboxUpdate = (index, unitObj, setSelectedItem) => {
    setSelectedItem((prevSelectedItem) => {
      const updatedQuantity = [...prevSelectedItem.quantity];
      const existingUnitIndex = updatedQuantity.findIndex(
        (unit) => unit.unit === unitObj.unit
      );
  
      // Check for last checked unit
      if (existingUnitIndex !== -1 && 
          updatedQuantity[existingUnitIndex].isChecked && 
          updatedQuantity.filter(unit => unit.isChecked).length === 1) {
        showNotification("You must have at least one unit checked.", "Warning");
        return prevSelectedItem;
      }
  
      if (existingUnitIndex === -1) {
        updatedQuantity.push({
          index,
          unit: unitObj.unit,
          formula: unitObj.value,
          isChecked: true,
          value: 0,
        });
      } else {
        if (updatedQuantity[existingUnitIndex].isChecked) {
          updatedQuantity.splice(existingUnitIndex, 1);
        } else {
          updatedQuantity[existingUnitIndex].isChecked = true;
        }
      } // console.log(updatedQuantity,"before");
      updatedQuantity.sort((a, b) => {
        const unitA = prevSelectedItem?.unit_levels.find(u => u.unit === a.unit);
        const unitB = prevSelectedItem?.unit_levels.find(u => u.unit === b.unit);
        return unitA.value - unitB.value;
      });
      // console.log(updatedQuantity,"after");
  
      return { ...prevSelectedItem, quantity: updatedQuantity };
    });
  };
  // Update Units Quantity
  const handleQuantityUpdate = (index, quantity ,newunit,setSelectedItems) => {
    setSelectedItems(prevSelectedItems => {
      // const updatedUnits = prevSelectedItems.quantity.map((unit, i) =>
      //  newunit === unit.unit ? { ...unit, value: quantity } : i === index ? { ...unit, value: quantity } : unit
      // );
      // return { ...prevSelectedItems, quantity: updatedUnits };
      return {
        ...prevSelectedItems,
        quantity: prevSelectedItems.quantity.map((u) => u.unit === newunit ? { ...u, value: quantity } : u)
      }
    });
  };

  // Check Threshold function 
  const checkThreshold = (unit_levels, available, unit_for_threshold,threshold) => {
    const unitLevelsCopy = JSON.parse(JSON.stringify(unit_levels));
    const availableCopy = JSON.parse(JSON.stringify(available));
    const missingUnits = unitLevelsCopy?.filter(unit => !availableCopy.some(avail => avail.unit === unit.unit))
                                        .map(unit => ({ unit: unit.unit, value: 0 }));
    const arrange = availableCopy?.concat(missingUnits);
    const result = [...arrange];
    let isOutOfStock = false;
    for (let index = 1; index < unitLevelsCopy.length; index++) {
        result[index].value += (arrange[index - 1].value * unitLevelsCopy[index].value);
        if (result[index].unit === unit_for_threshold && result[index].value < threshold) {
            isOutOfStock = true;
            break;
        }
    }
    // console.log(result)
    // console.log(isOutOfStock)
    return isOutOfStock;
  };

  // Check Out of stock
  function checkOutOfStock(available) {
    for (const unit of available) {
      if (unit.value !== 0) {
          return false; // If all teh units are 0, return false
      }
  }
  return true;
  }

  function getMaxValueForUnit(availableQuantities, unitLevels, targetUnit) {
    const conversions = {};

    unitLevels.forEach(level => {
        conversions[level.unit] = level.value;
    });

    const baseUnit = availableQuantities.find(q => conversions[q.unit]);
    const baseQuantity = baseUnit ? baseUnit.value : 0;

    if (!baseUnit || !conversions[targetUnit]) {
        // console.log("Invalid input or target unit not found.");
        return 0;
    }

    const baseUnitConversion = conversions[baseUnit.unit];
    const targetUnitConversion = conversions[targetUnit];
    const conversionFactor = targetUnitConversion / baseUnitConversion;
    const maxQuantity = Math.floor(baseQuantity * conversionFactor);

    // Add any existing quantity of the target unit
    const targetQuantity = availableQuantities.find(q => q.unit === targetUnit);
    const targetValueToAdd = targetQuantity ? targetQuantity.value : 0;

    // const outputQuantity = maxQuantity + targetValueToAdd;
    const outputQuantity = maxQuantity ;
    // console.log(outputQuantity, "Maximum Quantity");
    return outputQuantity;
  }

  function CheckExpiryDateValidation(POItems, freeGoods) {
    const today = moment().startOf('day');
    const regularItemsWithIssues = POItems.filter(item => {
      if (!item.receive?.some(({ value }) => value != 0)) return false;
      if (!item.expiry_date) return true;      
      return moment(item.expiry_date).isBefore(today);
    });
  
    const freeGoodsWithIssues = freeGoods.filter(item => {
      if (!item.receive?.some(({ value }) => value != 0)) return false;
      if (!item.expiry_date) return true;
      return moment(item.expiry_date).isBefore(today);
    });
  
    let warningMessage = "";
  
    if (regularItemsWithIssues.length > 0) {
      warningMessage += "Following items have missing or invalid expiry dates:\n" +
        regularItemsWithIssues.map(item => {
          const issue = !item.expiry_date ? 
            "missing expiry date" : 
            "expiry date cannot be in the past";
          return `<strong>• ${item.name}</strong> (${issue})`;
        }).join('\n');
    }
  
    if (freeGoodsWithIssues.length > 0) {
      warningMessage += "\n\nFollowing free goods have missing or invalid expiry dates:\n" +
        freeGoodsWithIssues.map(item => {
          const issue = !item.expiry_date ? 
            "missing expiry date" : 
            "expiry date cannot be in the past";
          return `<strong>• ${item.name}</strong> (${issue})`;
        }).join('\n');
    }
  
    return {
      isValid: !warningMessage,
      message: warningMessage
    };
  }

export {handleCheckboxChange,handleQuantityChange
   ,handleCheckboxUpdate,handleQuantityUpdate,checkThreshold,checkOutOfStock,getMaxValueForUnit,
   CheckExpiryDateValidation}